import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  description: {
    marginBottom: spacing(2),
  },
  actions: {
    marginTop: spacing(6),
    flexDirection: "row",
    gap: spacing(4),
  },
  action: {
    flex: 1,
  },
}));

export default stylesheet;
